import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function _templateObject10() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  width: 100%;\n  justify-content: space-between;\n  align-items: center;\n  position: relative;\n"]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = _taggedTemplateLiteral(["\n  padding-bottom: 10px;\n  "]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n    //   width: auto;\n    // "]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  position: relative;\n  padding-bottom: 22px;\n  &:not(:last-child) {\n    width: 100%;\n    // ", "\n  }\n  a {\n    display: flex;\n    align-items: center;\n  }\n  ", "\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  z-index: -1;\n  width: 100%;\n  height: 2px;\n  background-color: ", ";\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  right: 0;\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n    font-size: 16px;\n    line-height: 110%;\n  "]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  display: block;\n  font-size: 20px;\n  line-height: 1em;\n  color: ", ";\n  margin-left: 11px;\n  margin-top: 2px;\n  ", "\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n    display: none;\n  "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n    width: 24px;\n    height: 24px;\n  "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  width: 36px;\n  height: 36px;\n  position: relative;\n  border-radius: 50%;\n  background-color: ", ";\n  box-shadow: 0 0 0 3px\n    ", ";\n  color: #fff;\n  text-align: center;\n  line-height: 1em;\n  font-size: 14px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  ", "\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import { media, styled } from "@styles";
export var Dot = styled.div(_templateObject(), function (props) {
  if (props.active) {
    return "#C34C3E";
  }

  if (props.done) {
    return "#000";
  }

  return "rgba(131, 144, 152, .3)";
}, function (props) {
  return props.active ? "rgba(195, 76, 62, 0.3)" : "trarnsparent";
}, media.xxLargeScreen(_templateObject2()), media.largeScreen(_templateObject3()));
export var Label = styled.span(_templateObject4(), function (props) {
  return props.done ? "#2C2C2C" : "#839098";
}, media.largeScreen(_templateObject5()));
export var ProgressBar = styled.div(_templateObject6(), function (props) {
  return props.done ? "#C34C3E" : "rgba(0,0,0,.1)";
});
export var Step = styled.div(_templateObject7(), media.xxLargeScreen(_templateObject8()), media.largeScreen(_templateObject9()));
export var Wrapper = styled.div(_templateObject10());